var BASE_URL = '/browse/m/composer';
var formatComposerName = function formatComposerName(firstName, lastName) {
  var safeFirstName = (firstName || '').toLowerCase();
  var safeLastName = (lastName || '').toLowerCase();
  return [safeFirstName, safeLastName].filter(Boolean).join('-');
};
export default function getComposerUrl(composer) {
  var firstName = composer.firstName,
    lastName = composer.lastName,
    id = composer.id;
  var safeComposerName = formatComposerName(firstName, lastName);
  return "".concat(BASE_URL, "/").concat(safeComposerName, "_").concat(id);
}